import React from 'react';
import { BsClock } from 'react-icons/bs';
import { LuInbox } from 'react-icons/lu';
import { MdAllInbox } from 'react-icons/md';
import { formatTimeAgo } from '../../utils/Date';

const TicketList = ({
  sortedTickets,
  selectedTicket,
  activeFilter,
  handleSelectTicket,
  handleFilterChange,
}) => {
  const isUnread = ticket => !ticket.isRead;

  return (
    <div className="w-1/4 border-r border-gray-200 overflow-y-auto">
      {/* Filter tabs */}
      <div className="flex border-b border-gray-200">
        <button
          className={`flex-1 py-4 flex flex-col items-center justify-center ${
            activeFilter === 'all' ? 'text-gray-700 border-b-2 border-black' : 'text-gray-500'
          }`}
          onClick={() => handleFilterChange('all')}>
          <MdAllInbox className="text-xl" />
          <span className="text-xs mt-1">All</span>
        </button>
        <button
          className={`flex-1 py-4 flex flex-col items-center justify-center ${
            activeFilter === 'open' ? 'text-gray-700 border-b-2 border-black' : 'text-gray-500'
          }`}
          onClick={() => handleFilterChange('open')}>
          <LuInbox className="text-xl" />
          <span className="text-xs mt-1">Open</span>
        </button>
        <button
          className={`flex-1 py-4 flex flex-col items-center justify-center ${
            activeFilter === 'closed' ? 'text-gray-700 border-b-2 border-black' : 'text-gray-500'
          }`}
          onClick={() => handleFilterChange('closed')}>
          <BsClock className="text-xl" />
          <span className="text-xs mt-1">Closed</span>
        </button>
      </div>

      {/* Ticket list */}
      <div className="divide-y divide-gray-200">
        {sortedTickets.map(ticket => {
          const unread = isUnread(ticket);
          // Filter replies to include only userId or businessId replies
          const userReplies = ticket.replies
            ? ticket.replies.filter(reply => reply.userId || reply.businessId)
            : [];

          // Sort user replies in descending order by createdAt
          const sortedUserReplies = userReplies.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );

          // Determine the latest message
          const latestMessage =
            sortedUserReplies.length > 0 ? sortedUserReplies[0].message : ticket.message;

          // Determine the latest update timestamp
          const latestUpdatedAt =
            sortedUserReplies.length > 0 ? sortedUserReplies[0].createdAt : ticket.updatedAt;

          return (
            <button
              key={ticket._id}
              className={`w-full cursor-pointer hover:bg-gray-50 ${
                selectedTicket?._id === ticket._id ? 'bg-gray-50' : ''
              } ${unread ? 'border-l-4 border-blue-500' : ''}`}
              onClick={() => handleSelectTicket(ticket._id)}>
              <div className="flex p-4 relative">
                <div className="flex-shrink-0 mx-5 relative">
                  <div className="w-9 h-9 bg-black text-white flex items-center justify-center text-xl font-medium">
                    {ticket?.userId?.firstName?.charAt(0) || 'NA'}
                  </div>
                  {/* New message indicator dot */}
                  {unread && (
                    <div className="absolute -top-1 -right-1 w-3 h-3 bg-blue-500 rounded-full"></div>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center mb-1">
                    {ticket.status === 'open' && (
                      <span className="bg-blue-100 text-blue-700 text-[9px] px-2 py-0.5 rounded mr-2">
                        New
                      </span>
                    )}
                    {ticket.status === 'closed' && (
                      <span className="bg-red-100 text-red-700 text-[9px] px-2 py-0.5 rounded mr-2">
                        Closed
                      </span>
                    )}
                    {/* Display time ago */}
                    <span className="text-[9px] text-gray-500 ml-auto">
                      {formatTimeAgo(latestUpdatedAt)}
                    </span>
                  </div>
                  <div className="flex items-center mb-1">
                    <span className={`text-xs font-medium ${unread ? 'font-bold' : ''}`}>
                      {ticket?.userId?.firstName || ''} {ticket?.userId?.lastName || ''}
                    </span>
                  </div>
                  <h3
                    className={`text-[9px] font-light text-gray-500 w-[50%] text-start truncate ${
                      unread ? 'font-semibold text-gray-700' : ''
                    }`}>
                    {ticket?.subject}
                  </h3>
                </div>
              </div>
            </button>
          );
        })}

        {sortedTickets.length === 0 && (
          <div className="p-8 text-center">
            <p className="text-sm text-gray-500">
              {activeFilter === 'open'
                ? 'No open tickets found'
                : activeFilter === 'closed'
                ? 'No closed tickets found'
                : 'No tickets found'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TicketList;
